<template>
    <router-link class="promo-card" :to="{name: 'PromoDetail', params: {promotionId: promo.id}}" tag="div">
        <div style="width: -webkit-fill-available;">
            <div class="promo-picture">
                <v-img
                    contain
                    height="200px"
                    :src="promo.imageUrl"
                />
            </div>
            <div class="promo-description">
                <div class="promo-description-title">
                    {{ promo.name }}
                </div>
                <div class="promo-description-text">
                    Срок действия акции
                </div>
                <div class="promo-description-time">
                    Бессрочно
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'PromoItem',

        props: {
            color: { type: String },
            promo: { type: Object },
        },

        computed: {
            //
        },

        methods: {
            //
        },
    }
</script>

<style scoped>
    .promo-card {
        max-width: 100%;
        width: 356px;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        padding: 0px;

        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 0px;
        padding: 12px 16px;

        border: 1.5px solid rgb(228, 228, 228);
        border-radius: 12px;
        cursor: pointer;
    }
    .mobile .promo-card {
        width: calc(100vw - 24px);
    }
    .promo-card.selected {
        border-color: #DA251C;
    }
    .promo-picture {
        border-radius: 10px;
        margin-bottom: 12px;
    }
    .promo-description {
        margin-bottom: 14px;
    }
    .promo-description-title {
        color: rgb(54, 57, 59);
        font-size: 16px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .promo-description-text {
        color: rgb(54, 57, 59);
        font-size: 14px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .promo-description-time {
        color: rgb(54, 57, 59);
        font-size: 14px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: left;
    }
    .station-actions {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .station-select-btn {
        max-width: 80%;
        width: 262px;
        height: 54px !important;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 16px 40px 16px 40px;

        flex: none;
        order: 0;
        flex-grow: 0;
        /* margin: 0px 8px; */

        box-sizing: border-box;
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: #fff !important;
        color: #DA251C;

        font-size: 16px;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0%;
    }
    .v-btn.station-select-btn.selected {
        border: 1.5px solid rgb(232, 232, 232);
        border-radius: 10px;
        background-color: rgb(232, 232, 232) !important;
    }
    .v-btn.station-select-btn.selected .btn-text {
        color: rgb(143, 143, 143);
    }
    .station-select-btn .btn-text {
        color: rgb(54, 57, 59);
    }
    .station-select-btn:hover {
        background: #fff !important;
        border: 1.5px solid #DA251C;
    }
    .station-map-btn {
        width: 54px !important;
        height: 54px;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        /* padding: 16px 40px 16px 40px; */

        flex: none;
        order: 1;
        flex-grow: 0;
        /* margin: 0px 8px; */

        box-sizing: border-box;
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: rgb(218, 37, 28);
        padding: 0 !important;
    }
    .station-select-btn.view:hover {
        border: 1.5px solid rgb(218, 37, 28);
        border-radius: 10px;
        background: rgb(218, 37, 28) !important;
    }
    .station-select-btn.view:hover .btn-text{
        color: white;
    }
    .station-map-btn.view {
        background-color: white;
    }
    .station-map-btn.view:hover {
        background: rgb(218, 37, 28) !important;
    }
    .station-map-btn.view:hover svg path {
        stroke: white;
    }
</style>
